import type { RouteObject } from 'react-router';
import { AdminPackageRegistriesPage } from '../pages/admin-package-registries-page';
import { AdminPackageRegistryDetailPage } from '../pages/admin-package-registry-detail-page';
import { AdminVulnerabilitySyncPage } from '../pages/admin-vulnerability-sync-page';

export const adminPackageRegistriesRoutes: RouteObject[] = [
  { path: 'package-registries', element: <AdminPackageRegistriesPage /> },
  { path: 'package-registries/:registryId', element: <AdminPackageRegistryDetailPage /> },
  { path: 'vulnerability-sync', element: <AdminVulnerabilitySyncPage /> },
];
